(function () {
  function initProductHighlightsSlider() {
    const sliderEl = document.querySelector('#product-highlights-slider');
    if (!sliderEl) return;

    // Splide slider is for mobile view only
    if (window.innerWidth > 990) return;

    // Prevent duplicate mounting
    if (sliderEl.classList.contains('is-initialized') || sliderEl.classList.contains('is-active')) {
      return;
    }

    // Wait until Splide constructor is available
    if (typeof Splide === 'undefined') {
      setTimeout(initProductHighlightsSlider, 60);
      return;
    }

    const extensions =
      window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll
        ? { AutoScroll: window.splide.Extensions.AutoScroll }
        : window.splide && window.splide.Extensions
        ? window.splide.Extensions
        : {};

    const splideInstance = new Splide(sliderEl, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      autoWidth: true,
      gap: '12px',
      arrows: false,
      pagination: false,
      clones: 8,
      autoScroll: {
        speed: 0.6,
        pauseOnHover: true,
        pauseOnFocus: false,
      },
    });

    splideInstance.mount(extensions);
    sliderEl.classList.add('is-initialized');

    // Pause AutoScroll when out of viewport to preserve main thread and keep INP low
    if ('IntersectionObserver' in window && splideInstance.Components && splideInstance.Components.AutoScroll) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const autoScroll = splideInstance.Components.AutoScroll;
            if (!autoScroll) return;
            if (entry.isIntersecting) {
              if (autoScroll.isPaused && autoScroll.isPaused()) {
                autoScroll.play();
              }
            } else {
              autoScroll.pause();
            }
          });
        },
        { rootMargin: '100px' }
      );
      observer.observe(sliderEl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductHighlightsSlider);
  } else {
    initProductHighlightsSlider();
  }

  // Handle mobile resize/orientation change
  window.addEventListener(
    'resize',
    function () {
      if (window.innerWidth <= 990) {
        initProductHighlightsSlider();
      }
    },
    { passive: true }
  );
})();